/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Recovery_CopiedInputs */

const en_two_fa_recovery_copied = /** @type {(inputs: Two_Fa_Recovery_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recovery codes copied.`)
};

const nl_two_fa_recovery_copied = /** @type {(inputs: Two_Fa_Recovery_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herstelcodes gekopieerd.`)
};

/**
* | output |
* | --- |
* | "Recovery codes copied." |
*
* @param {Two_Fa_Recovery_CopiedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_recovery_copied = /** @type {((inputs?: Two_Fa_Recovery_CopiedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Recovery_CopiedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_recovery_copied(inputs)
	return en_two_fa_recovery_copied(inputs)
});